module.exports = __webpack_public_path__ + "img/plan.0a5180c.PNG";